export class EmpleadoSemanaModel {
  id?: string;
  meta?: EmpleadoMetaDia[] = [];
  tienda?: string;
  semana?: string;

  empleado?: string;
  metaTotal?: number;
  fecha?: string;

  observaciones: string[] = [];

  obsTemp: string = '';

  constructor() {
    for (let i = 0; i < 7; i++) {
      let md = new EmpleadoMetaDia();
      md.dia = i;
      md.metaDia = 0;
      this.meta.push(md);
    }
  }

  calcularTotal() {
    this.metaTotal = 0;


    this.meta.map(me => {
      me.calcularTotal();


      this.metaTotal += me.metaDia;
    });

  }

  public static CrearEmpleadoSemana(data) {


    if (data == null)
      return null;

    let es = new EmpleadoSemanaModel();
    es.id = data.id;
    es.meta.map((m, i) => {
      m.metaDia = data.meta[i].metaDia;
      m.metaHora = data.meta[i].metaHora;
      m.dia = data.meta[i].dia;
      m.horario = data.meta[i].horario;
      m.fecha = data.meta[i].fecha;
      m.esCompensado = data.meta[i].esCompensado;

    });
    // es.meta = data.meta;
    es.tienda = data.tienda;
    if (data.observaciones)
      es.observaciones = data.observaciones;
    es.obsTemp = (es.observaciones.length > 0) ? es.observaciones[0] : '';
    es.semana = data.semana;
    es.empleado = data.empleado;
    // es.metaTotal = data.metaTotal;
    es.calcularTotal();

    return es;
  }
}


export class EmpleadoMetaDia {
  dia?: number;
  metaHora?: number[] = [];
  metaDia?: number;
  horario?: boolean[] = [];
  fecha?: string;
  esCompensado?: boolean = false;

  constructor() {
    for (let i = 0; i < 48; i++) {
      this.metaHora.push(0);

      this.horario.push(false);
    }
    this.metaDia = 0;
  }

  calcularTotal() {
    this.metaDia = 0;
    this.metaHora.map(mh => {
      this.metaDia += mh;
    });
  }

}
